import type { IntlShape } from 'react-intl'
import type { AccountingPeriodHeader } from './types'

export const accountingPeriodHeaders: AccountingPeriodHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Nimi',
				description: 'Table column header: Name',
			}),
		key: 'name', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ensimmäinen päivä',
				description: 'Table column header: First day',
			}),
		key: 'firstDay', //TODO:
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viimeinen päivä',
				description: 'Table column header: Last day',
			}),
		key: 'lastDay', //TODO:
		show: true,
		sortable: true,
		type: 'date',
	},
]

export const accountingPeriodDialogHeaders: AccountingPeriodHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Nimi',
				description: 'Table column header: Name',
			}),
		key: 'name', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ensimmäinen päivä',
				description: 'Table column header: First day',
			}),
		key: 'firstDay', //TODO:
		show: true,
		sortable: true,
		type: 'date',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viimeinen päivä',
				description: 'Table column header: Last day',
			}),
		key: 'lastDay', //TODO:
		show: true,
		sortable: true,
		type: 'date',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lukituspäivä',
				description: 'Table column header: Lock day',
			}),
		key: 'lockDay', //TODO:
		show: true,
		sortable: true,
		type: 'date',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lukittu',
				description: 'Table column header: Locked',
			}),
		key: 'locked', //TODO:
		show: true,
		sortable: true,
		type: 'boolean',
		fullWidth: true,
	},
]
